import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";

import Tatoo from "../works/img/tatoo.jpg";


export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Add an empty dependency array to run the effect only once

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }
  return (
    <>
      <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>TATOO</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>2023</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>none</span> 
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <span style={{color:"#063dcc"}} >Comming Soon</span>

                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}} >Comming Soon</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum id justo ac risus dictum dapibus. Nulla facilisi. Phasellus id ante in libero eleifend sodales vel nec purus. Sed malesuada euismod ligula, non bibendum eros tincidunt in. Maecenas nec tincidunt metus. Quisque in bibendum tortor. Integer egestas risus quis turpis gravida, et faucibus orci volutpat. Nullam fringilla velit nec felis posuere, eget lacinia felis eleifend. Donec ac lectus et libero consectetur aliquet.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Sed interdum vitae augue ut posuere. Fusce viverra, quam non feugiat euismod, ex est bibendum libero, nec tincidunt dui neque in tellus. Praesent ac rhoncus sapien. Curabitur sollicitudin tortor vel ligula tincidunt, nec tincidunt lectus sodales. Suspendisse potenti. Sed eu tincidunt orci. Sed ac sapien ac odio varius convallis nec a purus. Proin et massa vitae justo congue bibendum.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Contact />
    </>
  );
}
